import React from 'react'
import * as firebase from "firebase";



export default class ConvosList extends React.Component {
    constructor(props) {
        super(props)
        this.checkSignedIn = this.checkSignedIn.bind(this)
        this.state = {value: '',isLoggedIn: false, userID:null,messages:[],convoRef:'',convoIDs:[]};
        this.renderConvoVeiw = this.renderConvoVeiw.bind(this);
        this.renderConvodVeiw = this.renderConvosVeiw.bind(this);
        this.componentWillMount = this.componentWillMount.bind(this);
        this.getConvos = this.getConvos.bind(this);
    }

    componentWillMount() {
        this.checkSignedIn()
    }

    signOut(){
        console.log("signing user out");
        alert("signing out");
       firebase.auth().signOut().then(function() {
            // Sign-out successful.
        }).catch(function(error) {
            // An error happened.
        });

    }
    handleSignOut(){
        console.log("signing user out");
        alert("signing out");

    }
    checkSignedIn() {

        var state = this
        firebase.auth().onAuthStateChanged(function (user) {
            if (user) {
                console.log("singed in : " + user.phoneNumber);
                state.setState({isLoggedIn: true});
                state.setState({userID: user.phoneNumber.replace(/\D/g, '')});
                this.setState({convoRef:'users/'+this.state.userID + '/convos/'});
                state.getConvos();

            } else {

                console.log("singed out");
                state.setState({isLoggedIn: false});

            }
        }.bind(this));

    }
    getConvos(){

        if(this.state.isLoggedIn) {
            console.log("tried to get convo");

            var state = this;

            var convoRef = firebase.database().ref(this.state.convoRef);
            convoRef.on('child_added', function (data) {
                var convoID = data.val();
                console.log(convoID)
                var convoIDs = state.state.convoIDs;
                convoIDs.push(convoID);
                console.log(convoIDs)
                state.setState({convoIDs: convoIDs})
                console.log(state.state.convoIDs.length);
            }.bind(this));
        }
    }


    renderConvoVeiw(convoID){

        return   <div> <button onClick={()=>window.location = '/#/chat/'+convoID}>{convoID}</button></div>;

    }


    renderConvosVeiw(){
        var state = this;
        return this.state.convoIDs.map(function ( convoID) { debugger;

            return state.renderConvoVeiw(convoID);

        })
    }


    render() {

        const isLoggedIn = this.state.isLoggedIn;

        return <div id="content">

            <section id="chat_section">
                {this.renderConvosVeiw()}
            </section>
        </div>

    }


}






// WEBPACK FOOTER //
// ./src/components/pages/ConvosList.jsx